import JobDetail from './JobDetail';

export default JobDetail;
